import { Button, FileInput, Spinner } from 'flowbite-react';
import React, { useState } from 'react';
import { BiCheck, BiCheckbox, BiCheckCircle, BiCheckDouble, BiCheckShield } from 'react-icons/bi';
import { BsCheckCircleFill } from 'react-icons/bs';
import { GiGreenPower } from 'react-icons/gi';
import { getPolicyForS3NonVideo } from 'src/apis/user';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';
import { handleS3Upload } from 'src/utils/imageUpload';

interface Props {
	// file: File;
	// setFile: (file: File) => void;
	uploadedUrl: string;
	setUploadedUrl: (url: string) => void;
	headingText?: string;
	acceptedFormats?: string;
	acceptedFormatText?: string;
	isPublic?: boolean;
	isDisabled?: boolean;
}

const UploadDocument = ({
	isPublic = true,
	acceptedFormats,
	acceptedFormatText,
	uploadedUrl,
	setUploadedUrl,
	headingText,
	isDisabled,
}: Props) => {
	const [file, setFile] = useState<File>();
	const toast = useToast();
	const { user } = useUserContext();
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const handleUploadDocument = async () => {
		if (file) {
			const fileSizeMB = file.size / (1024 * 1024); // Convert bytes to MB
			if (fileSizeMB > 5) {
				toast({
					type: 'error',
					title: 'File size exceeds the maximum limit of 5 MB',
					duration: 10000,
				});
				return;
			}
			setIsLoading(true);
			let imageUrl = '';
			if (file && user) {
				// fileName, fileLocation, mime
				const policy = await getPolicyForS3NonVideo(file.name, 'profileImages', file.type, isPublic);
				const uploadedUrl = await handleS3Upload(policy, file);
				if (uploadedUrl) imageUrl = uploadedUrl;
				if (imageUrl) {
					setUploadedUrl(imageUrl);
				}
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		}
	};

	return (
		<div className="grid gap-[8px] border rounded-[8px] p-[8px]">
			<p className="mb-[4px]">
				{headingText || 'Upload document here'}
				<span className="text-red-600">*</span>
			</p>
			<p className="mb-[8px]">(Accepted formats: {acceptedFormatText || '.png, .jpeg'}, max file size: 5mb)</p>

			<div className="flex gap-[16px]">
				<FileInput
					accept={acceptedFormats || 'image/png, image/jpeg'}
					id="profileImage"
					name="profileImage"
					onChange={event => {
						if (event.target && event.target.files) {
							setFile && setFile(event.target.files[0]);
						}
					}}
				/>
				<Button
					onClick={handleUploadDocument}
					className=" h-fit"
					color="purplePlaced"
					disabled={isLoading || isDisabled}
				>
					{isLoading ? <Spinner /> : 'Upload'}
				</Button>
			</div>
			{uploadedUrl && (
				<p className="mb-[8px] flex items-center gap-[8px]">
					<BsCheckCircleFill color="green" />
					Done
					{/* <a className="text-[#7777E7]" href={uploadedUrl} target="_blank">
						Link
					</a> */}
				</p>
			)}
		</div>
	);
};

export default UploadDocument;
